export type IncludeExcludePathConflict =
  | {
      type: "exact";
      includedPath: string;
      excludedPath: string;
    }
  | {
      type: "excluded-ancestor";
      includedPath: string;
      excludedPath: string;
    };

function normalizePathForComparison(path: string) {
  let normalized = path.trim().replace(/\\/g, "/").replace(/\/+/g, "/");
  if (normalized.length > 1) normalized = normalized.replace(/\/+$/, "");
  return normalized;
}

function isStrictAncestorPath(ancestorPath: string, descendantPath: string) {
  const ancestor = ancestorPath.toLowerCase();
  const descendant = descendantPath.toLowerCase();

  if (ancestor === descendant) return false;
  if (ancestor === "/") return descendant.startsWith("/");
  return descendant.startsWith(`${ancestor}/`);
}

export function findIncludeExcludePathConflict(
  includedPaths: string[],
  excludedPaths: string[],
): IncludeExcludePathConflict | null {
  const normalizePath = (path: string) => {
    const original = normalizePathForComparison(path);
    return { original, comparable: original.toLowerCase() };
  };
  const normalizedIncludedPaths = includedPaths.map(normalizePath);
  const normalizedExcludedPaths = excludedPaths.map(normalizePath);

  for (const excludedPath of normalizedExcludedPaths) {
    const includedPath = normalizedIncludedPaths.find(
      (path) => path.comparable === excludedPath.comparable,
    );
    if (includedPath) {
      return {
        type: "exact",
        includedPath: includedPath.original,
        excludedPath: excludedPath.original,
      };
    }
  }

  for (const excludedPath of normalizedExcludedPaths) {
    const includedPath = normalizedIncludedPaths.find((path) =>
      isStrictAncestorPath(excludedPath.original, path.original),
    );
    if (includedPath) {
      return {
        type: "excluded-ancestor",
        includedPath: includedPath.original,
        excludedPath: excludedPath.original,
      };
    }
  }

  return null;
}
